<template>
  <div class="f-item-progressing">
    <div class="icon">
      <f-icon icon="fa6-file" class="s32"></f-icon>
    </div>
    <div class="name" :content="name" v-tippy>
      {{ name || "default file name" }}
    </div>
    <div class="action">
      <f-button
        type="icon tertiary negative small"
        @click.stop="completed || error ? $emit('dismiss') : $emit('cancel')"
      >
        <font-awesome-layers class="fa-lg">
          <font-awesome-icon icon="fa-regular fa-circle"></font-awesome-icon>
          <font-awesome-icon
            icon="fa-solid fa-close"
            transform="shrink-6"
          ></font-awesome-icon>
        </font-awesome-layers>
      </f-button>
    </div>
    <div class="f-progress">
      <!-- <f-fade-transition> -->
      <f-loader-circular
        size="16px"
        key="pending"
        :progress="progress"
        :completed="completed"
        :error="error"
        :pending="pending"
      ></f-loader-circular>

      <!-- </f-fade-transition> -->
    </div>
  </div>
</template>
<script>
export default {
  props: {
    icon: {
      type: String,
      default: "fa6-file",
    },
    name: String,
    progress: Number,
    completed: Boolean,
    error: Boolean,
    pending: Boolean,
  },
};
</script>
<style lang="scss">
.f-item-progressing {
  height: 64px;
  display: flex;
  width: 100%;
  justify-content: space-between;
  gap: 8px;
  align-items: center;
  // background-color: hsla(350, 100%, 88%, 0.5);
  border-bottom: 1px solid var(--greyLight);
  color: var(--black-a75);
  padding: 8px 16px;

  > .icon {
    width: 32px;
    height: 32px;
    flex: 0 0 32px;
    color: var(--turquoise);
  }

  > .name {
    flex: 1 1 auto;
    color: var(--black-a75);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 56px;
  }

  > .action,
  > .f-progress {
    flex: 0 0 40px;
  }

  > .action {
  }

  > .f-progress {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
  }
}

.dark-mode {
  .f-item-progressing {
    color: var(--white-a75);
    border-bottom: 1px solid var(--white-a25);

    > .icon {
      color: var(--primary);
    }

    > .name {
      color: var(--white-a75);
    }
  }
}
</style>